import React from "react";
import { Article } from "../../types";
import ArticleCard from "../ArticleCard/ArticleCard";
import "./ArticleFeed.css";

interface ArticleFeedProps {
  articles: Article[];
  isLoading: boolean;
  error: string | null;
}

const ArticleFeed: React.FC<ArticleFeedProps> = ({
  articles,
  isLoading,
  error,
}) => {
  return (
    <main className="article-feed">
      {isLoading && <p className="feed-message">Loading articles...</p>}
      {error && <p className="feed-message error">{error}</p>}
      {!isLoading && !error && articles.length === 0 && (
        <p className="feed-message">No articles found for this category.</p>
      )}
      <div className="articles-grid">
        {articles.map((article) => (
          <ArticleCard key={article.link} article={article} />
        ))}
      </div>
    </main>
  );
};

export default ArticleFeed;
